module.exports = __webpack_public_path__ + "static/media/RecomendaFozIguacu.9ec8f8b7.jpg";